/* eslint-disable */
"use client";
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
  SelectField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getPattern } from "./graphql/queries";
import { updatePattern } from "./graphql/mutations";
const client = generateClient();
export default function PatternUpdateForm(props) {
  const {
    id: idProp,
    pattern: patternModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    danceStyles,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    danceStylePatternsId: "",
    name: "",
    status: true,
    order: "",
  };
  const [danceStylePatternsId, setDanceStylePatternsId] = React.useState(
    initialValues.danceStylePatternsId
  );
  const [name, setName] = React.useState(initialValues.name);
  const [status, setStatus] = React.useState(initialValues.status);
  const [order, setOrder] = React.useState(initialValues.order);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = patternRecord
      ? { ...initialValues, ...patternRecord }
      : initialValues;
    setDanceStylePatternsId(cleanValues.danceStylePatternsId);
    setName(cleanValues.name);
    setStatus(cleanValues.status);
    setOrder(cleanValues.order);
    setErrors({});
  };
  const [patternRecord, setPatternRecord] = React.useState(patternModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getPattern.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getPattern
        : patternModelProp;
      setPatternRecord(record);
    };
    queryData();
  }, [idProp, patternModelProp]);
  React.useEffect(resetStateValues, [patternRecord]);
  const validations = {
    danceStylePatternsId: [{ type: "Required" }],
    name: [{ type: "Required" }],
    status: [],
    order: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          danceStylePatternsId,
          name,
          status: status ?? null,
          order: order ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updatePattern.replaceAll("__typename", ""),
            variables: {
              input: {
                id: patternRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "PatternUpdateForm")}
      {...rest}
    >
      <SelectField
        label="Dance Style"
        isRequired={true}
        value={danceStylePatternsId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              danceStylePatternsId: value,
            };
            const result = onChange(modelFields);
            value = result?.danceStylePatternsId ?? value;
          }
          if (errors.danceStylePatternsId?.hasError) {
            runValidationTasks("danceStylePatternsId", value);
          }
          setDanceStylePatternsId(value);
        }}
        onBlur={() =>
          runValidationTasks("danceStylePatternsId", danceStylePatternsId)
        }
        errorMessage={errors.danceStylePatternsId?.errorMessage}
        hasError={errors.danceStylePatternsId?.hasError}
        {...getOverrideProps(overrides, "danceStylePatternsId")}
      >
        <option value="">Select a dance style</option>
        {danceStyles.map((danceStyle) => (
          <option key={danceStyle.id} value={danceStyle.id}>
            {danceStyle.name}
          </option>
        ))}
      </SelectField>
      <TextField
        label="Name"
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              status,
              order,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <SwitchField
        label="Status"
        defaultChecked={false}
        isDisabled={false}
        isChecked={status}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              name,
              status: value,
              order,
            };
            const result = onChange(modelFields);
            value = result?.status ?? value;
          }
          if (errors.status?.hasError) {
            runValidationTasks("status", value);
          }
          setStatus(value);
        }}
        onBlur={() => runValidationTasks("status", status)}
        errorMessage={errors.status?.errorMessage}
        hasError={errors.status?.hasError}
        {...getOverrideProps(overrides, "status")}
      ></SwitchField>
      <TextField
        label="Order"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={order}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              name,
              status,
              order: value,
            };
            const result = onChange(modelFields);
            value = result?.order ?? value;
          }
          if (errors.order?.hasError) {
            runValidationTasks("order", value);
          }
          setOrder(value);
        }}
        onBlur={() => runValidationTasks("order", order)}
        errorMessage={errors.order?.errorMessage}
        hasError={errors.order?.hasError}
        {...getOverrideProps(overrides, "order")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || patternModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || patternModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
